import { render, staticRenderFns } from "./PartnersNew.vue?vue&type=template&id=65d887fc&scoped=true"
import script from "./PartnersNew.vue?vue&type=script&lang=js"
export * from "./PartnersNew.vue?vue&type=script&lang=js"
import style0 from "./PartnersNew.vue?vue&type=style&index=0&id=65d887fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d887fc",
  null
  
)

export default component.exports